import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

function MyDashboardHeader() {
  const { tTitle } = useI18nHelper();

  return (
    <Flex
      height={"48px"}
      minHeight={"48px"}
      paddingX={"16px"}
      alignItems={"center"}
      borderBottom={"0.5px solid #D4D4D1"}
      background={"#FFFFFF"}
    >
      <Text textStyle={"heading-sm"}>{tTitle("my_dashboard")}</Text>
    </Flex>
  );
}

export default MyDashboardHeader;
